import type { RawParams, Transition } from "@uirouter/react";

import { logWithTransitionScope } from "app/sentry/utils/logWithTransitionScope";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { getAppCategoryStore } from "app/pages/app-intelligence/constants";
import { AppsResourceService } from "app/services/AppsResourceService";
import type { IRouterState, RouterStateConfig } from "single-spa/react-app/router/IRouterState";

const swConfig: RouterStateConfig = {
    digitalsuite_marketresearch_appmarketanalysis_home: {
        parent: "digitalsuite_marketresearch",
        url: "/markets/appmarketanalysis/home",
        onEnter: ($transition$: Transition) => {
            // Prevent the URL from changing
            $transition$.abort();
            logWithTransitionScope($transition$, "onEnter", "INFO - industryResearchAppMarketAnalysisConfig - digitalsuite_marketresearch_appmarketanalysis_home");
            // Redirect to external site
            window.location.href = getAppCategoryStore(null);
        },
        configId: "AppMarketAnalysisHome",
        configIdDeps: ["TopApps", "TopAppsGoogle", "TopAppsApple"],
        secondaryBarType: "DigitalSuiteMarketResearch",
        isSecondaryBarOpen: true,
        pageId: {
            section: "marketresearch",
            subSection: "marketresearch",
            subSubSection: "analyzeapps",
        },
        trackingId: {
            section: "App Intelligence",
            subSection: "App Category Analysis/Home",
            subSubSection: "App Market Analysis",
        },
        pageTitle: "marketintelligence.marketresearch.appmarketanalysis.homepage.title",
    },
    digitalsuite_marketresearch_appmarketanalysis: {
        abstract: true,
        parent: "digitalsuite_marketresearch",
        configId: "TopApps",
        secondaryBarType: "DigitalSuiteMarketResearch",
        data: {
            menuId: "appcategory",
            menuKbItems: "top-apps",
            disableRecording: true,
            showConnectedAccountsGlobalHook: true,
        },
        url: "/marketresearch/appmarketanalysis",
        resolve: [
            {
                token: "storeOptions",
                resolveFn: () => AppsResourceService.storeOptions(),
            },
        ],
    },
    digitalsuite_marketresearch_appmarketanalysis_top: {
        parent: "digitalsuite_marketresearch_appmarketanalysis",
        url: "/top/:store/:country/:category/:device/:mode/:duration?filter",
        onEnter: ($transition$: Transition) => {
            const params = $transition$.params();
            const { store } = params;
            // Prevent the URL from changing
            $transition$.abort();
            logWithTransitionScope($transition$, "onEnter", "INFO - industryResearchAppMarketAnalysisConfig - digitalsuite_marketresearch_appmarketanalysis_top");
            // Redirect to external site
            window.location.href = getAppCategoryStore(store);
        },
        secondaryBarType3: SecondarySideBarType3.AppMarket,
        stateNameForEductionBar: "marketresearch_appmarketanalysis_top",
        configId: (toState: IRouterState, toParams: RawParams) => {
            return "TopApps" + (toParams ? toParams.store : "");
        },
        configIdDeps: ["TopApps"],
        pageTitle: "rankings.topapps.title",
        pageSubtitle: "topapps.lastupdated",
        pageId: {
            section: "topapps",
            subSection: "category",
            subSubSection: "categoryanalysis",
        },
        trackingId: {
            section: "App Intelligence",
            subSection: "App Category Analysis",
            subSubSection: "topApps",
        },
        defaultParams: {
            mode: "Top Free",
        },
        params: {
            category: { type: "string", raw: true },
        },
        homeState: "digitalsuite_marketresearch_appmarketanalysis_home",
    },
    digitalsuite_marketresearch_appmarketanalysis_trending: {
        parent: "digitalsuite_marketresearch_appmarketanalysis",
        url: "/trending/:store/:country/:category/:device/:mode",
        onEnter: ($transition$: Transition) => {
            const params = $transition$.params();
            const { store } = params;
            // Prevent the URL from changing
            $transition$.abort();
            logWithTransitionScope($transition$, "onEnter", "INFO - industryResearchAppMarketAnalysisConfig - digitalsuite_marketresearch_appmarketanalysis_trending");
            // Redirect to external site
            window.location.href = getAppCategoryStore(store);
        },
        secondaryBarType3: SecondarySideBarType3.AppMarket,
        stateNameForEductionBar: "marketresearch_appmarketanalysis_trending",
        configId: (toState: IRouterState, toParams: RawParams) => {
            return "TopAppsTrends" + (toParams ? toParams.store : "");
        },
        configIdDeps: ["TopApps", "TopAppsTrendsGoogle", "TopAppsTrendsApple"],
        pageTitle: "rankings.trendingapps.title",
        pageSubtitle: "topapps.lastupdated",
        icon: "sw-icon-trends",
        pageId: {
            section: "topapps",
            subSection: "category",
            subSubSection: "trends",
        },
        trackingId: {
            section: "App Intelligence",
            subSection: "App Category Analysis",
            subSubSection: "trendingApps",
        },
        defaultParams: {
            mode: "Top Free",
        },
        params: {
            category: { type: "string", raw: true },
        },
        reloadOnSearch: false,
        homeState: "digitalsuite_marketresearch_appmarketanalysis_home",
    },
};

export const appMarketAnalysisConfig: RouterStateConfig = {
    ...swConfig,
};
